import React from 'react';
import PDFViewer from '../PDFViewer/PDFViewer';

interface SharedPDFViewerProps {
  url: string;
}

const SharedPDFViewer: React.FC<SharedPDFViewerProps> = ({ url }) => {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#f5f5f5'
    }}>
      <PDFViewer
        url={url}
        title="공유 PDF 문서"
        showControls={true}
        isFullscreen={true}
        onError={(error) => {
          console.error('PDF 로드 오류:', error);
        }}
        onDownload={() => {
          // 다운로드 링크 생성
          const link = document.createElement('a');
          link.href = url;
          link.download = 'shared-document.pdf';
          link.click();
        }}
      />
    </div>
  );
};

export default SharedPDFViewer;
